import { render } from "./ButtonCta.vue?vue&type=template&id=e31e92da"
import script from "./ButtonCta.vue?vue&type=script&lang=js"
export * from "./ButtonCta.vue?vue&type=script&lang=js"
script.render = render

export default script